module.exports = __webpack_public_path__ + "assets/img/5-2.3079aa32.png";